import { AnalysisTableHeader } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-table-header"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { AnalysisTableRow } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-table-row"
import React from "react"
import { Grid2, Paper, Typography } from "@mui/material"

export function AnalysisTable({ data, columns, title }) {
    return (
        <Grid2 size={12}>
            <Paper elevation={3}>
                {title && (
                    <Typography mt={2} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                        {title}
                    </Typography>
                )}
                <AnalysisTableHeader columns={columns} />
                <PagedRepeat list={data} item={<AnalysisTableRow columns={columns} />} />
            </Paper>
        </Grid2>
    )
}
